/*!
 * egt.preview.tinduns — readable preview for egt.tin.duns values.
 * { ein:"123456789", duns:"", payPersonal:false, noInfo:true } -> "EIN 12-3456789" / "Not available yet"
 */
var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.preview.tinduns",
  title: "Control Preview: TIN / DUNS",
  description: "Read-only preview for egt.tin.duns values.",
  fields: {
    value: { title: "Value", type: "*", description: "tin/duns object (or JSON string)." }
  }
});

var helper = require("../../uat/src/elements/helpers/control.preview.js");

function parse(value) {
  if (typeof value === "string") {
    try { return JSON.parse(value); } catch (error) { return {}; }
  }
  return (value && typeof value === "object") ? value : {};
}

function toLines(options) {
  var v = parse(options.value);
  var lines = [];
  if (v.ein) lines.push("EIN " + (v.ein.length === 9 ? v.ein.slice(0, 2) + "-" + v.ein.slice(2) : v.ein));
  if (v.duns) lines.push("DUNS " + v.duns);
  if (v.payPersonal) lines.push("Paying personally — a passion project");
  if (v.noInfo) lines.push("Not available yet");
  return lines;
}

exports.render = async function (options) {
  return helper.renderDoc(helper.jsonLines(toLines(options), "ua-control-preview-lines"));
};

/* Plain-text twin of render() for non-DOM surfaces (emails, logs, exports):
 * the same readable value, as a string. "" means nothing to show. */
exports.toText = function (options) {
  return toLines(options || {}).filter(Boolean).join("\n");
};
